<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="ContractAttachments"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <VueSlickgrid
    :name="gridName"
    :headerTitle="documentTitle"
    :items="ds"
    checkbox-row-selection
    export-to-csv
    :exportToCsvFilename="'contract-attachments'|pgettext('ExportFilename')"
    :columnDefaults="b_2248226175642056_columnDefaults"
    :columns="b_2248226175642056_columns"
    class="page--grid"
    ref="grid"
    @selectedRowsChanged="evh_2248226175642056_selectedRowsChanged($event, {})"
    @command="evh_2248226175642056_command($event, {})"
  >
    <DIV
      class="flex-grow-1 d-flex"
      slot="toolbar"
    >
      <PageHelp
        path="/products/products.html"
      >
      </PageHelp>
    </DIV>
  </VueSlickgrid>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "contractAttachments",
    path: "/contract-attachments",
    component: "ContractAttachments"
  }
)

@Component()
export default class ContractAttachments extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  gridName!: any;
  selectedItems!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('browse_contract_attachments')
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2248226175642056_columnDefaults!: any;
  b_2248226175642056_columns!: any;
  dataMembers = ['gridName', 'selectedItems', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        gridName: "contractAttachments",
        selectedItems: [
        ]
        ,
        ds: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2248226175642056_columnDefaults: {
          sortable: true,
          filterable: true,
          resizable: true,
        }
        ,
        b_2248226175642056_columns: [{
          field: "contract_revision",
          name: this.$fn.pgettext("ContractAttachments", "Contract"),
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    {{ $value.contract_number }}\n\
    {{~#if $value.revision_number }}\n\
      /{{ $value.revision_number }}\n\
    {{~/if }}\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "contract",
              navigateOnIconClick: true,
              params: {
                id: "contract_revision.contract_id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "file_name",
          name: this.$fn.pgettext("ContractAttachments", "File name"),
          useDataContext: true,
          displayFileName: true,
          formatter: "attachment",
          type: "command",
        }
          ,
        {
          field: "file_size",
          name: this.$fn.pgettext("ContractAttachments", "File size"),
          type: "number",
          formatter: "number",
        }
          ,
        {
          field: "description",
          name: this.$fn.pgettext("ContractAttachments", "Description"),
        }
          ,
        {
          field: "created_at",
          name: this.$fn.pgettext("BrowserColumn", "Create time"),
          formatter: "datetime",
        }
          ,
        {
          field: "created_by",
          name: this.$fn.pgettext("ContractAttachments", "Created by"),
          formatter: {
            name: "user",
          }
          ,
        }
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("ContractAttachments|Title", "Contract Attachments"),
        icon: this.$config.attachment.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_7266_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_7266, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_setData_7268_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2248226175642056_setData_7268, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_2248226175642056_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_script_7270_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_2248226175642056_script_7270, alias=undefined
    (console.log($event), this.$app.attachments.downloadAttachment($event.data.data))
  }

  async act_2248226175642056_script_7270_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_2248226175642056_script_7270, alias=undefined
    return {
      value: () => this.act_2248226175642056_script_7270_getActionArgs_value($event),
    }
  }

  async evh_2248226175642056_command_7269_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_7269, alias=undefined
    return $event.data.column.id === 'file_name'
  }

  async evh_2248226175642056_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_7266: actions.CloseModalAction;
    evh_7315092382398562_close_7265: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_setData_7268: actions.SetDataAction;
    evh_2248226175642056_selectedRowsChanged_7267: actions.EventHandlerImpl;
    evh_2248226175642056_selectedRowsChanged: actions.EventHandlerGroup;
    act_2248226175642056_script_7270: actions.ScriptAction;
    evh_2248226175642056_command_7269: actions.EventHandlerImpl;
    evh_2248226175642056_command: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_7266 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_7266_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_7265 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_7266,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_7265],
      }
    );
    const act_2248226175642056_setData_7268 = new actions.SetDataAction(
      {
        actionArgs: this.act_2248226175642056_setData_7268_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_selectedRowsChanged_7267 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_setData_7268,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_2248226175642056_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_selectedRowsChanged_7267],
      }
    );
    const act_2248226175642056_script_7270 = new actions.ScriptAction(
      {
        actionArgs: this.act_2248226175642056_script_7270_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_command_7269 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_script_7270,
        event: "command",
        when: this.evh_2248226175642056_command_7269_getWhen,
        displayName: "script",
      }
    );
    const evh_2248226175642056_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_command_7269],
      }
    );
    return {
      act_7315092382398562_closeModal_7266,
      evh_7315092382398562_close_7265,
      evh_7315092382398562_close,
      act_2248226175642056_setData_7268,
      evh_2248226175642056_selectedRowsChanged_7267,
      evh_2248226175642056_selectedRowsChanged,
      act_2248226175642056_script_7270,
      evh_2248226175642056_command_7269,
      evh_2248226175642056_command,
    }
  }
}

Vue.component("ContractAttachments", ContractAttachments);

</script>